module.exports = "../../../../platform/assets/pageMainIcon/industry_baobiaochaxunlei4.svg";